import React from "react"
import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";


import { TabList, TabPanel } from "@mui/lab";
import TabContext from '@mui/lab/TabContext';
import { Tab } from "@mui/material";

import authAxios from "../../components/authAxios";

import Layout from "../../components/Layout";
import DashboardHeader from "../../components/DashboardHeader";

import TransactionList from "./TransactionList";
import Loading from "../../components/Loading";
import CustomSearchBar from "../../components/CustomSearchBar";

const Transactions = () => {
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();
    const [searchText, setSearchText] = useState('');
    const removeBorder = true;

     // PAGINATION
     const handlePageChange = (event, value) => {
        setPage(value);
    };

    const { data: transactions } = useQuery({
        // queryKey: ['transactions', page],
        queryKey: ['transactions', page, searchText],
        queryFn: async () => {
            // const response = await authAxios.get(`/accounting/transactions/?page=${page}`);
            const response = await authAxios.get(`/accounting/transactions/?page=${page}&search=${searchText}`);
            setPageCount(response.data.page_count)
            return response.data.results
        },
    });

 
    return (
            <div className="dashboard-main">
                <section className="dashboard-content">
                    <div className="dashboard-content-header-nav">

                        <DashboardHeader dashboardTitle="Transactions" dashboardPreTitle="Accounting" />
                        <div className="dashboard-content-header-nav-icons">
                            <CustomSearchBar 
                                searchText={searchText}
                                setSearchText={setSearchText}
                            />
                        </div>
                    </div>
                  
                    <TransactionList 
                        module="ACC" 
                        transactions={transactions} 
                        handlePageChange={handlePageChange} 
                        page={page} 
                        pagecount={pagecount}
                    />

                </section>

            </div>

    );
  };
  
  export default Transactions;